import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";

import { skills } from "@/data";

const Skills = () => {
  return (
    <section id="skills" className="py-20">
      <motion.h2
        className="heading"
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.35 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        Skills & <span className="text-purple">Technologies</span>
      </motion.h2>
      <motion.p
        className="text-white-200 text-center mt-4 max-w-2xl mx-auto"
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.35 }}
        transition={{ duration: 0.5, delay: 0.08, ease: "easeOut" }}
      >
        A continuously evolving stack focused on building fast, scalable, and
        user-friendly digital products.
      </motion.p>

      <div className="mt-12 space-y-6">
        {[0, 1].map((rowIndex) => {
          const rowSkills = rowIndex === 0 ? skills : [...skills].reverse();
          const duplicatedSkills = [...rowSkills, ...rowSkills];
          const rowStyle = {
            "--animation-duration": rowIndex === 0 ? "32s" : "40s",
            "--animation-direction": rowIndex === 0 ? "forwards" : "reverse",
          } as React.CSSProperties;

          return (
            <motion.div
              key={rowIndex}
              className="relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,white_15%,white_85%,transparent)]"
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{
                duration: 0.5,
                delay: rowIndex * 0.08,
                ease: "easeOut",
              }}
            >
              <ul
                className="flex w-max gap-4 py-2 animate-scroll"
                style={rowStyle}
              >
                {duplicatedSkills.map((skill, idx) => (
                  <li
                    key={`${rowIndex}-${skill.id}-${idx}`}
                    className="interactive-lift flex items-center gap-3 rounded-xl border border-white/10 bg-black-200 px-4 py-3 min-w-[170px]"
                  >
                    <Image
                      src={skill.icon}
                      alt={skill.name}
                      width={20}
                      height={20}
                      className="object-contain"
                    />
                    <span className="text-white text-sm font-medium">
                      {skill.name}
                    </span>
                  </li>
                ))}
              </ul>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};

export default Skills;
